export default __webpack_public_path__ + "static/media/mask14.26ba11db.jpeg";